import ICONS_COLORS from './DSIconColor.js';
export { default as DSIconColors } from './DSIconColor.js';
import ICONS_SIZES from './DSIconSize.js';
export { default as DSIconSizes } from './DSIconSize.js';

var index = {
  DSIconColors: ICONS_COLORS,
  DSIconSizes: ICONS_SIZES
};

export default index;
//# sourceMappingURL=index.js.map
